// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1GGk1","footer":"ChangeClinic_footer__1YdoQ"};